import { config } from 'env_def';
import { apis } from '@/config';
import { api } from '@/api/api';
class RegisterApiImp {
    constructor() {
        this.isReady = false;
        this.isInited = false;
        this.version = config('version');
        this.name = apis.registerApiImpl;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.httpApi = api.getDataTransApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.loginApi = api.requireLogicalApi(apis.loginApiImpl);
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return user === null || user === void 0 ? void 0 : user.id;
    }
    async doValidateCode(params) {
        let res = {
            success: false,
        };
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('registerValidateCode'), Object.assign({}, params));
            const { data } = await this.httpApi.post(url);
            const { code, msg: message, data: info } = data || {};
            if (String(code) === '200') {
                res = {
                    success: true,
                    isRegister: false,
                    adminAccount: info === null || info === void 0 ? void 0 : info.adminAccount,
                    domain: info === null || info === void 0 ? void 0 : info.domain,
                };
            }
            else if (String(code) === '6020') {
                if (params.needGetBindAccount === undefined || params.needGetBindAccount) {
                    const { success, data: accountList, message: loginErrorMsg } = await this.loginApi.doMobileVerifyCode(params.code);
                    if (success) {
                        res = {
                            success: true,
                            isRegister: true,
                            data: accountList,
                        };
                    }
                    else {
                        res = {
                            success: false,
                            message: loginErrorMsg,
                        };
                    }
                }
                else {
                    res = {
                        success: true,
                        isRegister: true,
                        data: [],
                    };
                }
            }
            else {
                res = {
                    success: false,
                    message,
                };
            }
        }
        catch (e) {
            console.error('[register_impl] validateCode error', e);
            res = {
                success: false,
            };
        }
        return res;
    }
    async getRegisterDemandList() {
        try {
            const url = this.systemApi.getUrl('registerDemandList');
            const { data } = await this.httpApi.get(url);
            if (String(data === null || data === void 0 ? void 0 : data.code) === '200') {
                return data === null || data === void 0 ? void 0 : data.data.demandList;
            }
            return [];
        }
        catch (ex) {
            console.error('getRegisterDemandList error', ex);
            return [];
        }
        return [];
    }
    async getMailDomainInfo(params) {
        var _a;
        const res = {
            success: false,
            msg: '',
            data: null,
        };
        try {
            const url = this.systemApi.getUrl('registerMailDomainInfo');
            const { data } = await this.httpApi.post(url, params);
            const { code, msg: message } = data || {};
            if (String(code) === '200') {
                const unusedName = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.unusedName;
                if (unusedName) {
                    res.success = true;
                    res.data = unusedName;
                }
            }
            else {
                res.msg = message;
            }
        }
        catch (ex) {
            console.error('getMailDomainInfo error', ex);
        }
        return res;
    }
    async addRegisterAppendDemand(params) {
        const res = {
            success: false,
        };
        try {
            const url = this.systemApi.getUrl('registerAppendDemand');
            const { data } = await this.httpApi.post(url, params);
            const { code, msg: message } = data || {};
            if (String(code) === '200') {
                res.success = true;
            }
            else {
                res.message = message;
            }
        }
        catch (ex) {
            console.error('addRegisterAppendDemand error', ex);
        }
        return res;
    }
    async doCheckDomain(params) {
        let res = {
            success: false,
        };
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('registerCheckDomain'), Object.assign({ domainSuffix: 'freeqiye.com' }, params));
            const { data } = await this.httpApi.get(url);
            const { code, msg: message } = data || {};
            if (String(code) === '200') {
                res = {
                    success: true,
                };
            }
            else {
                res = {
                    success: false,
                    message,
                };
            }
        }
        catch (e) {
            console.error('[register_impl] checkDomain error', e);
            res = {
                success: false,
                message: e.message,
            };
        }
        return res;
    }
    async doSubmit(params) {
        var _a;
        let res = {
            success: false,
            sid: '',
        };
        try {
            const source = window && window.electronLib ? 'lx_desktop' : 'lx_web';
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('registerSubmit'), Object.assign({ source, domainSuffix: 'freeqiye.com' }, params));
            const { data } = await this.httpApi.post(url);
            const { code, msg: message } = data || {};
            if (String(code) === '200') {
                res.success = true;
                res.sid = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.sid;
            }
            else {
                res = {
                    success: false,
                    message,
                    code: code,
                };
            }
        }
        catch (e) {
            console.error('[register_impl] submit error', e);
            res = {
                success: false,
                message: e.message,
            };
        }
        return res;
    }
    init() {
        return this.name;
    }
    afterInit() {
        console.warn('[register_impl] afterInit');
        return this.name;
    }
    afterLogin() {
        return this.name;
    }
    beforeLogout() {
        return this.name;
    }
}
const impl = new RegisterApiImp();
api.registerLogicalApi(impl);
export default impl;
